module.exports = __webpack_public_path__ + "static/img/11.4760bc9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/3/sp/11.png
// module id = 7U7T
// module chunks = 0